import reframe from 'reframe.js';

export const videoLightbox = () => {
  // Create lightbox container
  const lightbox = document.createElement('div');
  lightbox.className = 'lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('tabindex', '-1'); // Make it focusable

  const lightboxContent = document.createElement('div');
  lightboxContent.className = 'lightbox-content';

  const closeButton = document.createElement('button');
  closeButton.textContent = 'Close';
  closeButton.className = 'close-btn';
  closeButton.setAttribute('aria-label', 'Close video');

  lightboxContent.appendChild(closeButton);
  lightbox.appendChild(lightboxContent);
  document.body.appendChild(lightbox);

  // Function to open lightbox
  const openLightbox = (url) => {
    const iframe = document.createElement('iframe');
    iframe.src = url.replace('watch?v=', 'embed/');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('aria-label', 'YouTube video');

    lightboxContent.appendChild(iframe);
    lightbox.style.display = 'flex';

    reframe('.lightbox-content iframe');
    closeButton.focus();
  };

  // Function to close lightbox
  const closeLightbox = () => {
    lightbox.style.display = 'none';
    lightboxContent.removeChild(lightboxContent.lastChild); // Remove the iframe
  };

  // Event listener for video items
  document.querySelectorAll('.videos-item').forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      const videoUrl = item.getAttribute('href');
      openLightbox(videoUrl);
    });
  });

  // Close lightbox when close button is clicked
  closeButton.addEventListener('click', closeLightbox);

  // Close lightbox when clicking outside of the iframe
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) {
      closeLightbox();
    }
  });

  // Close lightbox when pressing the ESC key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeLightbox();
    }
  });
};
